import { MoteDeleteButton } from '../MoteDeleteButton/MoteDeleteButton'
import { MoteDownloadButton } from '../MoteDownloadButton'
import type { MoteSaveToMotebookButtonProps } from '../MoteSaveToMotebookButton'
import { MoteSaveToMotebookButton } from '../MoteSaveToMotebookButton'
import { ThemedBackgroundHeader } from '../ThemedBackgroundHeader'
import type { TranscriptTranslateButtonProps } from '../TranscriptTranslateButton'
import { TranscriptTranslateButton } from '../TranscriptTranslateButton'
import {
  StyledButtonGroup,
  StyledPlayerHeaderContent
} from './PlayerHeader.styles'

type ButtonVisibility = {
  delete: boolean
  download: boolean
  star: boolean
  translate: boolean
}

export interface PlayerHeaderProps
  extends Pick<
    MoteSaveToMotebookButtonProps,
    'inMotebook' | 'getCanUseMotebook' | 'hasHitMotebookLimit' | 'title'
  > {
  onDelete: () => void
  onDownloadClick: () => void
  onStar: MoteSaveToMotebookButtonProps['onSave']
  onTranslate: TranscriptTranslateButtonProps['onChange']
  language: TranscriptTranslateButtonProps['value']
  saveToMoteBookTextOverwrite?: string
  saveToMoteBookForceTooltip?: boolean
  buttonVisibility: ButtonVisibility
  background?: 'neutral' | 'classic' | 'mulberry'
  isAuthenticated?: boolean
  withoutBackground?: boolean
}

export function PlayerHeader(props: PlayerHeaderProps): JSX.Element {
  const content = Object.values(props.buttonVisibility).some(Boolean) ? (
    <StyledPlayerHeaderContent>
      <StyledButtonGroup>
        {props.buttonVisibility.delete && (
          <MoteDeleteButton
            onDelete={props.onDelete}
            textPosition={'tooltip'}
          />
        )}
        {props.buttonVisibility.star && (
          <MoteSaveToMotebookButton
            forceTooltip={props.saveToMoteBookForceTooltip}
            textOverwrite={props.saveToMoteBookTextOverwrite}
            title={props.title}
            onSave={props.onStar}
            inMotebook={props.inMotebook}
            hasHitMotebookLimit={props.hasHitMotebookLimit}
            getCanUseMotebook={props.getCanUseMotebook}
            textPosition={'tooltip'}
          />
        )}
        {props.buttonVisibility.download && (
          <MoteDownloadButton
            onDownload={props.onDownloadClick}
            textPosition={'tooltip'}
          />
        )}
        {props.buttonVisibility.translate && (
          <div style={{ flex: 1 }}>
            <TranscriptTranslateButton
              textPosition={'inside'}
              onChange={props.onTranslate}
              value={props.language}
            />
          </div>
        )}
      </StyledButtonGroup>
    </StyledPlayerHeaderContent>
  ) : (
    <></>
  )

  if (props.withoutBackground) {
    return content
  }

  return (
    <ThemedBackgroundHeader
      background={props.background || 'neutral'}
      isAuthenticated={Boolean(props.isAuthenticated)}
    >
      {content}
    </ThemedBackgroundHeader>
  )
}
